module.exports = __webpack_public_path__ + "img/bg-moda.b53f535a.png";